export default __webpack_public_path__ + "static/media/icon_avatar_chat_4.8a84277b.svg";